module.exports = __webpack_public_path__ + "static/media/food-4.c1ae7bd1.jpeg";